module.exports = __webpack_public_path__ + "static/drow_matron_mother-6fefa9e1955ce930f066e785269c051b.png";